import { useEffect } from "react"

const useThemeColor = (lightColor = "#ffffff", darkColor = "#171717") => {
    useEffect(() => {
        const metaThemeColor = document.querySelector(
            'meta[name="theme-color"]',
        )

        const updateThemeColor = () => {
            //const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
            const savedMode = localStorage.getItem("darkMode")
            const prefersDarkMode = JSON.parse(savedMode) || false

            metaThemeColor?.setAttribute(
                "content",
                prefersDarkMode ? darkColor : lightColor,
            )
            if (prefersDarkMode) {
                document.documentElement.classList.add("dark")
            } else {
                document.documentElement.classList.remove("dark")
            }
        }

        updateThemeColor()

        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
        mediaQuery.addEventListener("change", updateThemeColor)
        return () => mediaQuery.removeEventListener("change", updateThemeColor)
    }, [lightColor, darkColor])
}

export default useThemeColor
